var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_8154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 3.125V7.9375C18.4336 7.9375 17.0625 9.30863 17.0625 11C17.0625 12.6914 18.4336 14.0625 20.125 14.0625V18.875H0.875V14.0625C2.56637 14.0625 3.9375 12.6914 3.9375 11C3.9375 9.30863 2.56637 7.9375 0.875 7.9375V3.125H20.125Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56348 14.9766L14.4385 7.10159",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21973 8.19534L7.65723 7.75784L8.09473 8.19534L7.65723 8.63284L7.21973 8.19534Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9072 13.8829L13.3447 13.4454L13.7822 13.8829L13.3447 14.3204L12.9072 13.8829Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_8154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/Manage.aee8d8767ae4b5090623372a0eba639d.svg";
export { ForwardRef as ReactComponent };